import { useTranslate } from 'core/hooks/useTranslate';
import { toAbsoluteUrl } from 'core/utils/utils';
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';

const PdfViewerFullScreen = ({ ariaLabel, url }) => {
  const { t } = useTranslate();
  pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;
  const [numPages, setNumPages] = useState(null);

  function onDocumentLoadSuccess({ numPages }) {
    setNumPages(numPages);
  }

  return (
    <section className="pdf-viewer-fullscreen" aria-label={ariaLabel}>
      <a className="pdf-viewer-fullscreen__download" href={toAbsoluteUrl(url)} target="_blank" rel="noopener noreferrer">
        {t('courses:Download PDF')}
        <span className="sr-only"> ({t('accessibility:Opens in new window')})</span>
      </a>
      <Document className="pdf-viewer-fullscreen__document" file={toAbsoluteUrl(url)} onLoadSuccess={onDocumentLoadSuccess}>
        {Array.from(new Array(numPages), (el, index) => (
          <Page className="pdf-viewer-fullscreen__page" pageNumber={index + 1} key={`page_${index + 1}`} />
        ))}
      </Document>
    </section>
  );
};

PdfViewerFullScreen.propTypes = {
  ariaLabel: PropTypes.string,
  url: PropTypes.string,
};

export default PdfViewerFullScreen;
